import Vue from 'vue';
import updatetime from './updatetime';
import OutGlobal from './global';
import {
    getTableHeight, Down, calculateFileSize, getdic, getLabel, checkObj,
    singleRepeat
} from "./utils";

Vue.prototype.$getTableHeight = window.GetTableHeight = getTableHeight;
Vue.prototype.$getdic = getdic;
Vue.prototype.$getLabel = getLabel;
Vue.prototype.$checkObj = checkObj;
Vue.prototype.$calculateFileSize = window.CalculateFileSize = calculateFileSize;
Vue.prototype.$down = window.Down = Down;
Vue.prototype.$singleRepeat = singleRepeat
Vue.prototype.$headersIp = window.HeadersIp = OutGlobal.ip ? { 'n-d-address': OutGlobal.ip, 'Accept-Language': 'zh-CN,zh;q=0.9' } : { 'Accept-Language': 'zh-CN,zh;q=0.9' };